export default __webpack_public_path__ + "assets/images/ee6606b19282724a0d0290bf61f3d910.png";